
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.84 17.222a.761.761 0 01-.876.222.73.73 0 01-.241-.164l-3.004-3.008a.75.75 0 011.06-1.06l1.721 1.732V4.25a.75.75 0 111.5 0v10.684l1.722-1.718a.749.749 0 111.059 1.06l-2.942 2.946h.001zM6.34 3.778a.762.762 0 00-.876-.222.731.731 0 00-.241.164L2.22 6.728a.75.75 0 001.06 1.06L5 6.057V16.75a.75.75 0 101.5 0V6.066l1.722 1.718a.748.748 0 001.278-.53.75.75 0 00-.219-.53L6.339 3.777l.001.001z","fill":"#069550"}})])
          )
        }
      }
    